import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const MasterAuthContext = createContext(null);

const TOKEN_KEY = "master_token";

export const masterApi = axios.create({ baseURL: API, timeout: 60000 });

masterApi.interceptors.request.use((config) => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) config.headers.Authorization = `Bearer ${t}`;
    if ((config.method || "get").toLowerCase() === "get") {
        config.params = { ...(config.params || {}), _t: Date.now() };
    }
    return config;
});

masterApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem(TOKEN_KEY);
            if (window.location.pathname.startsWith("/master") && window.location.pathname !== "/master/login") {
                window.location.href = "/master/login";
            }
        }
        return Promise.reject(err);
    },
);

export const MasterAuthProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const t = localStorage.getItem(TOKEN_KEY);
        if (!t) { setLoading(false); return; }
        masterApi.get("/master/auth/me")
            .then((r) => setAdmin(r.data))
            .catch(() => localStorage.removeItem(TOKEN_KEY))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const r = await masterApi.post("/master/auth/login", { email, password });
        localStorage.setItem(TOKEN_KEY, r.data.token);
        setAdmin(r.data.admin);
        return r.data.admin;
    };

    const logout = () => {
        localStorage.removeItem(TOKEN_KEY);
        setAdmin(null);
        window.location.href = "/master/login";
    };

    return (
        <MasterAuthContext.Provider value={{ admin, loading, login, logout }}>
            {children}
        </MasterAuthContext.Provider>
    );
};

export const useMasterAuth = () => useContext(MasterAuthContext);
